export const NAMES = {
  PERSON_FULL_NAME: 'fullName',
  PERSON_MIDDLE_NAME: 'middleName',
  PERSON_MOBILE_PHONE: 'mobilePhone',
  PERSON_FIO_CHANGED: 'isFioChanged',
  PERSON_MARITAL_STATUS: 'familyState',
  PERSON_SPOUSE: 'spouse',
  PERSON_TRUSTEES: 'trustees',
  PERSON_CHILDREN_COUNT: 'childrenCount',
  PERSON_DEPENDENT_COUNT: 'dependentCount',
  PERSON_EDUCATION: 'educationType',
  PREVIOUS_PERSON_FULL_NAME: 'prevFullName',
  PREVIOUS_PERSON_MIDDLE_NAME: 'prevMiddleName',
  PERSON_GENDER: 'gender',
};

export const PREVIOUS_MIDDLE_NAME_STRUCTURE = [
  'prevFullName',
  'prevLastName',
  'prevFirstName',
  'prevMiddleName',
];

export const MIDDLE_NAME_KEYS = {
  CURRENT: { value: NAMES.PERSON_MIDDLE_NAME, fullName: NAMES.PERSON_FULL_NAME },
  PREVIOUS: { value: NAMES.PREVIOUS_PERSON_MIDDLE_NAME, fullName: NAMES.PREVIOUS_PERSON_FULL_NAME },
};

export const MOBILE_PHONE_DEFAULT_VALUE = '+7 (___) ___-__-__';

export const PERSONAL_FORM_LABELS = {
  [NAMES.PERSON_FULL_NAME]: 'Фамилия*, имя*, отчество (необязательно)',
  [NAMES.PERSON_MOBILE_PHONE]: 'Мобильный телефон',
  [NAMES.PERSON_MARITAL_STATUS]: 'Семейное положение',
  [NAMES.PERSON_CHILDREN_COUNT]: 'Кол-во детей младше 21',
  [NAMES.PERSON_EDUCATION]: 'Образование',
  [NAMES.PERSON_FIO_CHANGED]: 'Ранее ФИО было изменено',
};
